import type { ExternalTableSchema } from '@packages/table-builder';

export const cashTransferTable: ExternalTableSchema = {
  metadata: {
    title: 'Cash Transfer',
    entity: 'CashTransfer',
  },

  dataSource: {
    endpoint:
      '/api/award-settlement/api/app/participant-cash-transfer-service/cash-transfer',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: 'table.searchText',
      Sorting: 'table.sorting',
      SkipCount: 'table.pageOffset',
      MaxResultCount: 'table.pageSize',
      CompanyIds: 'filters.companyIds',
      CashTransferStatusIds: 'filters.cashTransferStatusIds',
      TransferTypeIds: 'filters.transferTypeIds',
      RequestDate: 'filters.requestDate',
    },
    saveEndpoint:
      '/api/award-settlement/api/app/participant-cash-transfer-service/cash-transfer',
    saveMethod: 'PUT',
    confirmBeforeSave: {
      title: 'Save Changes',
      message: 'Are you sure you want to Save?',
      variant: 'warning',
    },
    onSaveSuccess: 'toastAndRefetch',
    saveSuccessMessage: 'Cash Transfer Edited.',
    filters: [
      {
        name: 'companyIds',
        placeholder: 'Company',
        type: 'asyncSelect',
        multiple: true,
        dataSource: {
          url: '/api/customer/api/app/participant-broker-account/company-list',
          labelField: 'companyName',
          valueField: 'id',
        },
      },
      {
        name: 'cashTransferStatusIds',
        placeholder: 'Transfer Status',
        type: 'asyncSelect',
        multiple: true,
        dataSource: {
          url: '/api/award-settlement/api/app/participant-cash-transfer-service/cash-transfer-status',
          labelField: 'name',
          valueField: 'id',
        },
      },
      {
        name: 'transferTypeIds',
        placeholder: 'Method',
        type: 'asyncSelect',
        multiple: true,
        dataSource: {
          url: '/api/award-settlement/api/app/participant-cash-transfer-service/transfer-types',
          labelField: 'name',
          valueField: 'id',
        },
      },
      {
        name: 'requestDate',
        placeholder: 'Request Date',
        type: 'date',
      },
    ],
  },

  columns: [
    {
      field: 'requestDate',
      header: 'Request Date',
      type: 'date',
      sortable: true,
      width: 180,
    },
    {
      field: 'company',
      header: 'Company',
      sortable: true,
      width: 180,
    },
    {
      field: 'participantName',
      header: 'Participant Details',
      type: 'couple',
      sortable: true,
      width: 150,
      couple: { titleField: 'participantName', subtitleField: 'employeeId' },
    },
    {
      field: 'sourceAccountNumber',
      header: 'Broker Account Number',
      sortable: false,
      width: 240,
      align: 'center',
    },
    {
      field: 'destinationAccountNumber',
      header: 'Destination Account Number',
      sortable: false,
      width: 240,
      align: 'center',
    },
    {
      field: 'amount',
      header: 'Amount',
      type: 'currency',
      sortable: true,
      width: 220,
      align: 'center',
      format: { decimals: 2 },
    },
    {
      field: 'methodType',
      header: 'Method',
      sortable: true,
      width: 240,
      align: 'center',
    },
    {
      field: 'cancelRequestedDate',
      header: 'Cancel Requested Date',
      type: 'date',
      sortable: true,
      width: 260,
      align: 'center',
    },
    {
      field: 'transferDate',
      header: 'Transfer Date',
      type: 'date',
      sortable: true,
      width: 220,
      align: 'center',
      editable: { type: 'dateTime', placeholder: 'MM/DD/YYYY h:mm' },
    },
    {
      field: 'status',
      header: 'Transfer Status',
      type: 'badge',
      sortable: true,
      width: 180,
      align: 'center',
      editable: { type: 'asyncSelect', defaultValueField: 'status' },
      dataSource: {
        url: '/api/award-settlement/api/app/participant-cash-transfer-service/cash-transfer-status',
        mapper: { label: 'name', value: 'name' },
      },
      badge: {
        statusMap: {
          'Pending Broker': 'info',
          'Broker Received': 'info',
          Failed: 'error',
          Transferred: 'success',
          Cancelled: 'error',
        },
        defaultVariant: 'info',
      },
    },
  ],

  actions: {
    row: [
      { id: 'VIEW_CASH_TRANSFER', label: 'View Details' },
      { id: 'EDIT_CASH_TRANSFER', label: 'Edit', actionType: 'startEditing' },
    ],
  },

  features: {
    search: { enabled: true },
    pagination: { mode: 'infiniteScroll', defaultSize: 10 },
    editing: {},
    columnPreferences: { persistenceKey: 'CashTransfer', resizable: true, reorderable: true },
  },
};
